import React from "react";
import { Columns, Table } from "@allxsmith/bestax-bulma";
import { formatCurrency, addVat } from "../../utils";
import logo from "../Nav/img/Logo.jpg";

class PrintJobQuote extends React.Component {
  PartRow(part) {
    return (
      <tr key={`p${part.id}`}>
        <td></td>
        <td></td>
        <td></td>
        <td>{part.name}</td>
        <td>{formatCurrency(part.customer_cost)}</td>
      </tr>
    );
  }

  WorkRow(work) {
    let rows = [];
    rows.push(
      <tr key={work.id} className="table-print-highlight">
        <td>{work.description}</td>
        <td>{work.labour_hours}</td>
        <td>{formatCurrency(work.customer_labour_cost)}</td>
        <td></td>
        <td></td>
      </tr>
    );
    rows = rows.concat(work.parts.map(part => this.PartRow(part)));
    return rows;
  }

  render() {
    const job = this.props.data;
    const work_items = job.work_items;


    let labourTotal = 0;
    let partsTotal = 0;

    for (let i = 0; i < work_items.length; i++) {
      if (work_items[i].chargeable === this.props.chargeable) {
        labourTotal +=
          1 * work_items[i].customer_labour_cost;
        for (let j = 0; j < work_items[i].parts.length; j++) {
          partsTotal +=
            1 * work_items[i].parts[j].customer_cost;
        }
      }
    }

    return (
      <div className="page print-landscape">
        <div>
          <Columns isMultiline>
            <h1 className="job-card-print-title" data-testid={"title"}>
              Job - {job.vehicle.registration} - {job.id}
            </h1>
          </Columns>
          <Table isBordered isFullwidth>
            <thead>
              <tr className="header-row">
                <td>Registration</td>
                <td>Make</td>
                <td>Model</td>
                <td>Customer</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={"vehicle-reg"}>{job.vehicle.registration}</td>
                <td data-testid={"vehicle-make"}>{job.vehicle.make ? job.vehicle.make.name : ""}</td>
                <td data-testid={"vehicle-model"}>{job.vehicle.model ? job.vehicle.model.name : ""}</td>
                <td data-testid={"customer"}>
                  {this.props.chargeable
                    ? job.customer2
                      ? job.customer2.display_name
                      : ""
                    : job.customer
                    ? job.customer.display_name
                    : ""}
                </td>
              </tr>
            </tbody>
          </Table>
          <Table isBordered isFullwidth>
            <thead>
              <tr className="header-row">
                <td>Description</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={"job-description"}>{job.job_description}</td>
              </tr>
            </tbody>
          </Table>
          <Table isBordered isFullwidth>
            <thead>
              <tr className="header-row">
                <td>Total Labour Cost</td>
                <td>Total Parts Cost</td>
                <td>Total Cost</td>
                <td>Total Cost (Inc VAT)</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={"total-labour-cost"}>{formatCurrency(labourTotal)}</td>
                <td data-testid={"total-parts-cost"}>{formatCurrency(partsTotal)}</td>
                <td data-testid={"total-cost"}>{formatCurrency(labourTotal + partsTotal)}</td>
                <td data-testid={"total-cost-vat"}>{formatCurrency(addVat(labourTotal + partsTotal))}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div>
          {
            <Table isBordered isFullwidth>
              <thead>
                <tr className="header-row">
                  <td>Work Description</td>
                  <td>Labour Hours</td>
                  <td>Labour Cost</td>
                  <td>Part Name</td>
                  <td>Part Cost</td>
                </tr>
              </thead>
              <tbody>
                {Object.entries(work_items).length > 0 &&
                  Object.entries(work_items)
                    .filter(
                      item => item[1].chargeable === this.props.chargeable
                    )
                    .sort((a, b) => a[0].description < b[0].description)
                    .map(entry => this.WorkRow(entry[1]))}
              </tbody>
            </Table>
          }
        </div>
        <p className="terms">All prices are excluding VAT. Our standard terms and conditions apply. A copy of
          these can be found on our website.</p>
      </div>
    );
  }
}

export default PrintJobQuote;
